import React, { useState, useEffect } from "react";
import "./ProjectCard.scss";
import PropTypes from "prop-types";

import Thumbnail from "components/Thumbnail";
// import Avatar from "components/Avatar";
import { Link } from "react-router-dom";
import { withFirebase } from "components/Firebase";

const ProjectCard = ({
  images,
  light,
  compact,
  basicInformation,
  tags,
  author,
  likes,
  category,
  user,
  id,
  firebase
}) => {
  // Hooks for heart state
  const [likeCount, incrementLikes] = useState(likes);

  useEffect(() => {
    if (likes) incrementLikes(likes);
  }, [likes]);

  const addLike = e => {
    e.preventDefault();
    firebase.heartProject(id, likeCount);
    incrementLikes(likeCount + 1);
  };

  return (
    <Link
      to={`/project/${id}`}
      className="ProjectCard"
      data-light={light}
      data-compact={compact}
    >
      {images[0] && (
        <Thumbnail height={compact ? 297 : 320} image={images[0].image} />
      )}

      <div className="Meta">
        {/* {author.avatar && <Avatar size={72} image={author.avatar} />} */}
        <div className="Info">
          <div>
            <div className="Category">
              <h6>{basicInformation.client}</h6>
            </div>
            <div className="Title">
              <h4>{basicInformation.title}</h4>
            </div>
          </div>
          <div className="SubInfo">
            <div className="Client">
              <h6>
                <Link to={`/u/${user.userName}`}>
                  {user.firstName} {user.lastName}
                </Link>
              </h6>
            </div>
            <div className="Date">{/* <h6>March, 2016</h6> */}</div>
          </div>
        </div>
        <div className="Footer">
          <div className="Likes" onClick={addLike}>
            <i className="ion ion-ios-heart" />
            {likeCount}
          </div>
          <div className="Tags">
            {tags.skills.length > 0 && (
              <div className="Tag">{tags.skills[0].label}</div>
            )}
            {/* <div className="more">+2</div> */} {/* TODO: Fix later */}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default withFirebase(ProjectCard);

ProjectCard.defaultProps = {
  title: "This is a test title",
  cover: "image missing",
  author: {
    name: "John Smith",
    avatar: "https://placehold.it/96x96"
  },
  likes: 0,
  category: "Category"
};

ProjectCard.propTypes = {
  image: PropTypes.string,
  avatar: PropTypes.string,
  light: PropTypes.bool,
  compact: PropTypes.bool
};
